
(function(template){
    define('vue!app/views/vue/components/cartComponent/cartBody/container',['Vue','vuex','vue!./userComponent','vue!../addGuestComponent/container','vuecal','vue!./scheduleButtonComponent','vue!app/views/vue/basicComponents/popup','vue!../popupLoginComponent/container','vue!./bookingIndicatorComponent','helpers','vue!./guestItinerary'],function(Vue,vuex,userComponent,addGuestComponent,vuecal,schedulebtn,popup, popupLoginComponent, bookingIndicatorComponent,helpers,guestItinerary ){
        return {
            template:template,
            components: {
                'user-component':userComponent,
                'add-guest-component' : addGuestComponent,
                "vue-cal": vuecal,
                "schedule-btn":schedulebtn,
                popup: popup,
                'popup-login-component' : popupLoginComponent,
                'booking-indicator-component' : bookingIndicatorComponent,
                'guest-Itinerary': guestItinerary
            },
            props:[
            "view_summary",'showCart'
            ],
            data: function(){
                return {
                    location: null,
                    buttonText: ['Schedule Services','Review Itinerary','Continue '],
                    show_list_view: true,
                    selectedEvent : {},
                    showDialog : false,
                    showAllDayEvents: false
                }
            },
            methods: _.extend(vuex.mapMutations(['setLoggedInUser','setActiveStep','addUserWithId']),{
                handleNextClick: function(){
                    if(this.disableButon) return;
                    if(this.activeStep==2) {
                        app.dispatcher.redirect('summary', 'checkout', [])
                        this.setActiveStep(0);
                        return;
                    }
                    this.setActiveStep(this.activeStep+1);
                },
                toggleCheckbox:function(){
                    this.show_list_view = !this.show_list_view
                },
               onEventClick:function(event,e){
                  
                     this.selectedEvent = event
                     this.$refs.package_item_conflict_popup.show()
                 // Prevent navigating to narrower view (default vue-cal behavior).
                 e.stopPropagation()
               },
               onChange:function(e){
                    const options = event.target.options;
                    const selectedOption = options[options.selectedIndex];
                   helpers.updateCalender(e.target.value,selectedOption.textContent) //id,name
               }
            }),
            computed: _.extend(
                vuex.mapState(['users',"selectedServices","loggedInUser",'activeStep','folioTotal','UserCalenderEvents','activeUser','desktopMode','currentlyEditingService','usersWithIds']),
                {
                    showUserNameComponent: function(){
                        return _.keys(this.users).length >= 1;
                    },
                    disableButon: function(){
                        var vm = this;
                        if(this.activeStep==0){
                            if(app.customization.spaBooking.packageBooking.scheduleServiceForEveryUser){
                                return _.keys(this.users).some(function(user){
                                    return _.keys(vm.users[user]).length == 0;
                                })
                            }
                            return !_.keys(this.users).some(function(user){
                                return _.keys(vm.users[user]).length > 0;
                            })
                        }
                        if(this.activeStep==1){
                            return _.keys(this.users).some(function(user){
                                return _.values(vm.users[user]).some(function(item){ return !item.SpaFolioItemId });
                            })
                        }
                    },

                    username: function(){
                        return Object.keys(this.users)[this.activeUser];
                    },

                    itemId: function(){
                    return Object.keys(this.users[this.username])[
                     this.currentlyEditingService]
                    },
                    isServiceBooked: function () { //returns if actice service is booked or not
                        if(this.username && this.itemId)
                         return !!this.users[this.username][this.itemId].SpaFolioItemId

                    },


                }
            ),
            watch:{
                  UserCalenderEvents:function(val){
                      var vm = this
                      vm.showAllDayEvents = false
                       _.each(val,function(booking){
                           if(booking.allDay) vm.showAllDayEvents = true
                       })
                    },
            },
            mounted: function(){
                var vm = this;
                app.models.spaModel.getData("spaLocations",{}).then(function(data){

                    data.SpaLocation.some(function(i){
                        if(i.LocationId == app.models.spaModel.dataModel.spaLocations.selectedValue){
                            vm.$data.location = i.LocationName;
                            return true;
                        }
                        return false;
                    })
                });
                if(app.data.userLoggedIn){
                    this.setLoggedInUser({userId:app.data.CustomerId});
                    this.addUserWithId({name: app.data.FirstName +" "+app.data.LastName, id: app.data.CustomerId});
                }else {
                    this.addUserWithId({name: this.localStrings.defaultUserName, id: app.data.CustomerId || app.data.DefaultCustomerId});
                }
            }
        }
    })
})('<div> <popup-login-component v-if="desktopMode"></popup-login-component> <guest-Itinerary :show_list_view="show_list_view" :view_summary="view_summary"></guest-Itinerary> <div class="cart-body grow" v-show="view_summary ||!desktopMode && show_list_view"> <div> <div> <!-- <booking-indicator-component v-if="!!loggedInUser && desktopMode" v-bind:is_service_booked="isServiceBooked"></booking-indicator-component> --> <div class="horizontal-line" v-if="activeStep>0"></div> <user-component :showCart="showCart" :showUserName="showUserNameComponent" :userId="userId" v-for="(userId,index) in Object.keys(users)" :key="index" :userIndex="index"></user-component> </div> <add-guest-component v-if="!singleBookingMode"></add-guest-component> </div> </div> <div class="side-cart-button"> <schedule-btn v-bind:is_service_booked="isServiceBooked" v-if="activeStep !=0 && desktopMode && customization.showBookBtnOnSideCart"></schedule-btn> </div> </div>');
